<template>
  <div></div>
</template>

<script>
export default {
  name: 'PageRedirect',
  mounted() {
    if (this.$route.name == 'home') {
      if (this.hasRole('ueg')) {
        this.$router.replace({ name: 'organizations' });
      } else {
        this.$router.replace({ name: 'projects.list' });
      }
    }
  }
};
</script>
